import { ListItemButton } from '@mui/material'
import Divider from '@mui/material/Divider'
import Icon from '@mui/material/Icon'
import List from '@mui/material/List'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import makeStyles from '@mui/styles/makeStyles'
import { getCategories } from 'lib/categories'
import { Link2Category } from 'lib/links'
import Link from 'next/link'

const useStyles = makeStyles((theme) => ({
  marginTop: {
    marginTop: '48px',
    [theme.breakpoints.up('sm')]: {
      marginTop: '64px'
    }
  },
  list: {
    width: '300px'
  }
}))

export default function Drawer ({ open, handleClose, handleOpen }) {
  const classes = useStyles()

  return (
    (
      <div>
        <SwipeableDrawer
          elevation={0}
          anchor='right'
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          classes={{ paper: classes.marginTop, root: classes.marginTop }}
          ModalProps={{
            BackdropProps: {
              classes: {
                root: classes.marginTop
              }
            }
          }}
        >
          <List component='nav' className={classes.list} dense>
            <Link href='/a-z' passHref legacyBehavior>
              <ListItemButton component='a' onClick={handleClose}>
                <ListItemIcon>
                  <Icon className={classes.icon}>sort_by_alpha</Icon>
                </ListItemIcon>
                <ListItemText primary='Sendungen A-Z' />
              </ListItemButton>
            </Link>
            <Link href='/sender' passHref legacyBehavior>
              <ListItemButton component='a' onClick={handleClose}>
                <ListItemIcon>
                  <Icon className={classes.icon}>settings_remote</Icon>
                </ListItemIcon>
                <ListItemText primary='Alle Sender' />
              </ListItemButton>
            </Link>
            <Link href='/live-tv' passHref legacyBehavior>
              <ListItemButton component='a' onClick={handleClose}>
                <ListItemIcon>
                  <Icon className={classes.icon}>live_tv</Icon>
                </ListItemIcon>
                <ListItemText primary='Live TV' />
              </ListItemButton>
            </Link>
            <Divider />
            <ListSubheader>Rubriken</ListSubheader>
            {getCategories().sort(compare).map((category) => (
              <Link2Category slug={category.slug} key={category.slug}>
                <ListItemButton component='a' onClick={handleClose}>
                  <ListItemIcon>
                    <Icon className={classes.icon}>{category.icon}</Icon>
                  </ListItemIcon>
                  <ListItemText primary={category.name} />
                </ListItemButton>
              </Link2Category>
            ))}
          </List>
        </SwipeableDrawer>
      </div>
    )
  )
}

function compare (a, b) {
  if (a.name > b.name) {
    return 1
  } else {
    return -1
  }
}
